module.exports = __webpack_public_path__ + "img/no-image.fec2d5c6.png";